import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DiscountPromotion } from "../../types/common.types";

type PromotionState = {
  promotions: DiscountPromotion[];
};

const initialState: PromotionState = {
  promotions: [],
};

const PromotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    setPromotions: (state, action: PayloadAction<DiscountPromotion[]>) => {
      state.promotions = action.payload;
    },
  },
});

export const { setPromotions } = PromotionSlice.actions;

export default PromotionSlice.reducer;
